import useFormApi from "@data-driven-forms/react-form-renderer/use-form-api";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/system";
import { Button } from "@mui/material";
import { ElementType } from "react";

interface AttributeValueFormTemplateProps {
  formFields: ElementType[],
  onSubmit: (data: any) => void;
}

export const AttributeValueForm = ({ formFields, onSubmit }: AttributeValueFormTemplateProps) => {
  const { getState } = useFormApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isSubmitting) return;
    const { values: updatedValues } = getState();
    onSubmit(updatedValues);
  }, [isSubmitting]);

  return (
    <form
      style={{
        width: 'auto'
      }}
      onSubmit={(event) => {
        event.preventDefault();
        setIsSubmitting(true);
      }}
    >
      <Grid container justifyContent="space-between" spacing={1}>
        {formFields}
      </Grid>

      <Button sx={{
        marginTop: '20px'
      }} variant={'contained'} onClick={() => setIsSubmitting(!isSubmitting)}>Submit</Button>

    </form>
  );
};
